import { matomo } from '@arr2019/stats-matomo';
import { MATOMO_SITE_ID, MATOMO_STATUS, MATOMO_URL } from '../generated/env.js';

export function initStats() {
  if (MATOMO_STATUS === 'active') {
    matomo({ MATOMO_SITE_ID, MATOMO_URL, enableCookies: false })
  }
}
